import React from 'react'

import HistoryWorkspacePage from './HistoryWorkspace'

const ReviewExport: React.FC = () => (
    <HistoryWorkspacePage mode="reviewExport" />
)

export default ReviewExport
